import modelRequest, { RequestError } from './lib/modelRequest'

interface PhonicsResponses {
  number: number
  response: string
  previousError: boolean
}

interface PhrasesResponses {
  phraseNumber: number
  responseNumber: number
  response: string
  previousError: boolean
}

interface StoriesResponses {
  paragraph: number
  centered: 'No' | 'Yes'
  lines: {
    line: number
    responses: {
      number: number
      response: string
      previousError: boolean
    }[]
  }[]
}

interface Probe {
  firstTime: boolean
  completedBefore: boolean
  title: string
  lastRead: number
  responsesMax: number
  studentCode: { code: string; expires: Date }
  responses: PhonicsResponses[] | PhrasesResponses[] | StoriesResponses[]
  valid: boolean
}

export default {
  /**
   * Gets the probe responses
   */
  get: (variables: {
    customerUsername?: string
    studentName?: string
    type: 'phrases' | 'phonics' | 'high' | 'middle' | 'elementary'
    number: number
  }): Promise<Probe & RequestError> => {
    return modelRequest.get('/api/probe', { params: { ...variables } })
  },
}
